import React from 'react';
import './map-style.scss';
import { Icons } from '../BootstrapComponents/BootstrapComponents';

export function FullScreenControl({ onClick = () => {}, fullScreen = false }) {
  return (
    <div className="full-screen-control">
      <button className="map-button" onClick={onClick}>
        <Icons icon={fullScreen ? 'full-screen-close' : 'full-screen'} customIcon />
      </button>
    </div>
  );
}
